export default {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint(state) {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl';
    if (state.windowWidth >= 992) return 'lg';
    if (state.windowWidth >= 768) return 'md';
    if (state.windowWidth >= 576) return 'sm';
    return 'xs';
  },

  scrollbarTag(state) {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar';
  },

  userIsLoggedIn(state, getters) {
    return getters['user/isLoggedIn'];
  },

  userHasToLogin(state, getters) {
    return getters['user/hasToLogin'];
  },
};
